// extracted by mini-css-extract-plugin
export default {"svg":"styles-module--svg--2pHHH","circle":"styles-module--circle--3A7PM"};